import { render, staticRenderFns } from "./eFooter.vue?vue&type=template&id=254ee8cb&scoped=true&"
var script = {}
import style0 from "./eFooter.vue?vue&type=style&index=0&id=254ee8cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254ee8cb",
  null
  
)

export default component.exports